module.exports = __webpack_public_path__ + "static/img/news_2.e414c3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/news_2.jpg
// module id = XmY1
// module chunks = 0